import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-brand">
            <span>IWantCheats</span>
          </div>
          <span>Your trusted source for undetectable game tools and instant support.</span>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/" onClick={scrollToTop}>Home</Link>
          <Link to="/about" onClick={scrollToTop}>About</Link>
          <Link to="/contact" onClick={scrollToTop}>Contact</Link>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <Link to="/terms" onClick={scrollToTop}>Terms of Service</Link>
          <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
          <Link to="/refund" onClick={scrollToTop}>Refund Policy</Link>
        </div>

        <div className="footer-section">
          <h4>Support</h4>
          <Link to="/contact" onClick={scrollToTop}>Help Center</Link>
          <Link to="/track-order" onClick={scrollToTop}>Track Order</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 IWantCheats. All rights reserved.</p>
      </div>

      <div className="footer-mobile">
        <p>
          <Link to="/terms" onClick={scrollToTop}>Terms of Service</Link> |
          <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link> |
          <Link to="/refund" onClick={scrollToTop}>Refund Policy</Link> |
          <Link to="/contact" onClick={scrollToTop}>Support</Link>
        </p>
        <p>© 2024 IWantCheats. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
